import config from 'configs/app';

// Use Next.js proxy when: (1) explicitly enabled, or (2) localhost vs remote API, or (3) app host !== API host (avoids CORS in production)
export default function isNeedProxy() {
  if (config.app.useProxy) {
    return true;
  }
  if (config.app.host === 'localhost' && config.app.host !== config.api.host) {
    return true;
  }
  if (config.app.host && config.api.host && config.app.host !== config.api.host) {
    return true;
  }
  return false;
}
